import React from 'react';
import PropTypes from 'prop-types';
import MText from '../common/MText';
import Colours from '../../styles/colours';

const DetailBox = (props) => (
  <div className={props.fullWidth ? 'col-12 mb-3' : 'col-12 col-md-6 mb-3'}>
    <div style={{ padding: '12px', backgroundColor: Colours.LightGray1, borderRadius: '4px', height: '100%' }}>
      <MText variant="caption" colour={Colours.Gray6} style={{ marginBottom: '4px', display: 'block' }} text={props.label} />
      <MText text={props.value} />
    </div>
  </div>
);

DetailBox.propTypes = {
  fullWidth: PropTypes.bool,
  label:     PropTypes.string,
  value:     PropTypes.string,
};

DetailBox.defaultProps = {
  fullWidth: false,
  label:     '',
  value:     '',
};

export default DetailBox;
